import createSvgIcon from '@ixigo/icons/utils/createSvgIcon';
import { Fragment } from 'react';

export const StateTax = createSvgIcon(
	<Fragment>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M18.6147 6.48656C18.9571 6.83612 19.1494 7.31024 19.1494 7.8046V9.41062C19.1494 10.3741 17.6823 10.3741 17.6823 9.41062V8.48363H15.5766C14.5684 8.48363 13.751 7.6491 13.751 6.61965V4.46967H6.84047C6.6425 4.46967 6.48202 4.63353 6.48202 4.83566V19.1075C6.48202 19.3097 6.6425 19.4735 6.84047 19.4735H10.9511C11.8997 19.4735 11.8997 20.9715 10.9511 20.9715H6.84047C5.83223 20.9715 5.01489 20.137 5.01489 19.1075V4.83566C5.01489 3.80621 5.83223 2.97168 6.84047 2.97168H14.4161C14.9003 2.97168 15.3646 3.16806 15.707 3.51763L18.6147 6.48656ZM16.0134 6.98564H17.2926L15.2182 4.86756V6.17365C15.2182 6.6221 15.5742 6.98564 16.0134 6.98564Z"
			fill="currentColor"
		/>
		<path
			d="M8.10722 9.92921C7.75033 9.92921 7.46102 10.2246 7.46102 10.589C7.46102 10.9534 7.75033 11.2488 8.10722 11.2488H12.9121C13.269 11.2488 13.5583 10.9534 13.5583 10.589C13.5583 10.2246 13.269 9.92921 12.9121 9.92921H8.10722Z"
			fill="currentColor"
		/>
		<path
			d="M7.47607 7.76993C7.47607 7.40554 7.76538 7.11014 8.12227 7.11014H10.9261C11.283 7.11014 11.5723 7.40554 11.5723 7.76993C11.5723 8.13433 11.283 8.42973 10.9261 8.42973H8.12227C7.76538 8.42973 7.47607 8.13433 7.47607 7.76993Z"
			fill="currentColor"
		/>
		<path
			d="M7.47998 13.419C7.47998 13.0546 7.76929 12.7592 8.12618 12.7592L10.206 12.7592C10.5629 12.7592 10.8522 13.0546 10.8522 13.419C10.8522 13.7834 10.5629 14.0788 10.206 14.0788L8.12618 14.0788C7.76929 14.0788 7.47998 13.7834 7.47998 13.419Z"
			fill="currentColor"
		/>
		<path
			d="M17.9769 14.0915C17.684 13.7986 17.2091 13.7986 16.9162 14.0915L14.0915 16.9162C13.7986 17.2091 13.7986 17.684 14.0915 17.9769C14.3844 18.2698 14.8593 18.2698 15.1522 17.9769L17.9769 15.1522C18.2698 14.8593 18.2698 14.3844 17.9769 14.0915Z"
			fill="currentColor"
		/>
		<path
			d="M15.4968 14.6218C15.4968 15.1051 15.1051 15.4968 14.6218 15.4968C14.1386 15.4968 13.7468 15.1051 13.7468 14.6218C13.7468 14.1386 14.1386 13.7468 14.6218 13.7468C15.1051 13.7468 15.4968 14.1386 15.4968 14.6218Z"
			fill="currentColor"
		/>
		<path
			d="M17.4465 18.3215C17.9298 18.3215 18.3215 17.9298 18.3215 17.4465C18.3215 16.9633 17.9298 16.5715 17.4465 16.5715C16.9633 16.5715 16.5715 16.9633 16.5715 17.4465C16.5715 17.9298 16.9633 18.3215 17.4465 18.3215Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.0342 21.0142C18.7956 21.0142 21.0342 18.7756 21.0342 16.0142C21.0342 13.2527 18.7956 11.0142 16.0342 11.0142C13.2728 11.0142 11.0342 13.2527 11.0342 16.0142C11.0342 18.7756 13.2728 21.0142 16.0342 21.0142ZM16.0342 19.5142C17.9672 19.5142 19.5342 17.9472 19.5342 16.0142C19.5342 14.0812 17.9672 12.5142 16.0342 12.5142C14.1012 12.5142 12.5342 14.0812 12.5342 16.0142C12.5342 17.9472 14.1012 19.5142 16.0342 19.5142Z"
			fill="currentColor"
		/>
	</Fragment>,
	'StateTax',
);

export default StateTax;
